// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__10Ix_","imageUploader":"EGiftCard_imageUploader__15ALo"};